import AvailableAgents from './AvailableAgents';

export default AvailableAgents;